import { combineReducers } from "redux";
import { Currency } from "../../types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { CREATE_CURRENCY_REQUEST, FETCH_CURRENCIES_REQUEST, UPDATE_CURRENCY_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: Currency[] = [], action: Action): Currency[] {
  switch (action.type) {
    case getSuccessActionType(CREATE_CURRENCY_REQUEST):
      return [...state, action.payload];

    case getSuccessActionType(FETCH_CURRENCIES_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CURRENCY_REQUEST):
      return state.map((currency) => (currency.id === action.data.currencyId ? action.payload : currency));

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case CREATE_CURRENCY_REQUEST:
    case FETCH_CURRENCIES_REQUEST:
    case UPDATE_CURRENCY_REQUEST:
      return true;

    case getSuccessActionType(CREATE_CURRENCY_REQUEST):
    case getFailureActionType(CREATE_CURRENCY_REQUEST):
    case getSuccessActionType(FETCH_CURRENCIES_REQUEST):
    case getFailureActionType(FETCH_CURRENCIES_REQUEST):
    case getSuccessActionType(UPDATE_CURRENCY_REQUEST):
    case getFailureActionType(UPDATE_CURRENCY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const currencies = combineReducers({ items, isFetching });
